import DefaultLayout from "@/layouts/DefaultLayout/DefaultLayout.vue"

import accountManageRoutes from "./modules/accountManage"
import audiencesRoutes from "./modules/audiences"
import authRoutes from "./modules/auth"
import automatedMarketingRoutes from "./modules/automatedMarketing"
import commonRoutes from "./modules/common"
import dataManage from "./modules/dataManage"
import marketing from "./modules/marketing"
import marketingResources from "./modules/marketingResources"
import notificationCenter from "./modules/notificationCenter"
import platformSettings from "./modules/platformSettings"

const routes = [
    {
        path: "/",
        name: "home",
        meta: {
            requiresAuth: true,
        },
    },
    ...authRoutes,
    ...commonRoutes,
    ...dataManage,
    ...audiencesRoutes,
    ...automatedMarketingRoutes,
    ...marketing,
    ...marketingResources,
    ...accountManageRoutes,
    ...platformSettings,
    ...notificationCenter,
    {
        path: "/about",
        name: "About",
        component: () => import("@/pages/About.vue"),
    },
    {
        path: "/redirect/:id",
        name: "redirect",
        component: DefaultLayout,
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: "",
                component: () => import("@/pages/RedirectPage.vue"),
                name: "redirect-index",
            },
        ],
    },
    {
        path: "/forbidden",
        name: "forbidden",
        component: DefaultLayout,
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: "",
                component: () => import("@/pages/ForbiddenPage.vue"),
                name: "forbidden-index",
            },
        ],
    },
    {
        path: "/:pathMatch(.*)*",
        component: DefaultLayout,
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: "",
                component: () => import("@/pages/NotFoundPage.vue"),
                name: "not-found",
            },
        ],
    },
]

export default routes
